"use strict";
const checkboxSelector = 'input:not([disabled])[name="publication_ids[]"]';
const modalHiddenInputSelector = '.js-recommendation_target_ids';
const openModalButtonSelector = '.js-open_recommendations_modal';
window.up.compiler(openModalButtonSelector, (button) => {
    window.up.on(button, 'click', undefined, () => {
        const allCheckboxes = Array.from(document.querySelectorAll(checkboxSelector));
        allCheckboxes.forEach(checkbox => {
            const selector = `${modalHiddenInputSelector}[value="${checkbox.value}"]`;
            const modalHiddenInput = document.querySelector(selector);
            if (modalHiddenInput) {
                modalHiddenInput.disabled = !checkbox.checked;
            }
        });
    });
});
